import React from "react";
import Card from "../../Cards";

class Main extends React.Component {
  render() {
    return (
      <React.Fragment>
        {this.props.media.overview && (
          <div className="rounded cursor-default border-b-2 shadow p-4 mb-4">
            <div className="font-bold mb-2">Overview</div>
            <p className="text-grey-dark text-grey-darker tracking-normal text-justify text-base whitespace-pre-line">
              {this.props.media.overview}
            </p>
          </div>
        )}

        <div className="flex flex-wrap -mx-2">
          {this.props.media.seasons &&
            this.props.media.seasons.map(season => {
              return (
                <Card
                  className="w-full lg:w-1/2 xl:w-1/3 px-2 mb-3 text-center"
                  divClassName="justify-center"
                  link={`${this.props.match.params.id}/season/${
                    season.season_number
                  }`}
                  description={season.overview}
                  title={season.name}
                  key={season.id}
                />
              );
            })}
        </div>
      </React.Fragment>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Media/TvShow/Main.js